/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CorpoListConCountItemDto } from '../../models/corpo-list-con-count-item-dto';

export interface ApiOrganicoCorpoListConCountGet$Params {
    /**
     * Id dell'unione per cui caricare i corpi
     */
    unioneId?: number;
}

export function apiOrganicoCorpoListConCountGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiOrganicoCorpoListConCountGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<CorpoListConCountItemDto>>> {
    const rb = new RequestBuilder(rootUrl, apiOrganicoCorpoListConCountGet.PATH, 'get');
    if (params) {
        rb.query('unioneId', params.unioneId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<CorpoListConCountItemDto>>;
        }),
    );
}

apiOrganicoCorpoListConCountGet.PATH = '/api/organico/corpo-list-con-count';
